import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { ArrowLeftFromLine, ArrowRightFromLine, X, Lock, LockOpen, Play, Trash2, SquareChartGantt } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import AddPreset from "./AddPreset"
import PresetTitlebar from "./PresetTitlebar"
import PresetsHandle from "./PresetsHandle"


const testPresets = [
  { _id: "7ghudwdgwdgcwec", subdomain: "woopla", rp: "257" },
  { _id: "yfvwhc8weyc7wdw", subdomain: "lifetimewell", rp: "109" },
  { _id: "7ghuwgcuwegcuee", subdomain: "sabrebrands", rp: "1090" },
  { _id: "323defher8hvrer", subdomain: "directmeds", rp: "285" },
  { _id: "sdc893tf3td374f", subdomain: "thevariantgroup", rp: "3307" },
]


export default function Presets({ location, template, className="" }:{ location:"build"|"preview"; template?:any; className?:string }){

  const { tmplid }:any = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore() 
  const { update } = AppStore 

  const { data:_Presets } = queryTools.resource.parseQueryForApi("preset.findAll", { template_id: template?._id }, { enabled: !!template._id })
  const savePresetFn = queryTools.resource.save([`preset.template${template._id}.all`])

  const [ expanded, setExpanded ] = useState(false)
  const [ presets, setPresets ] = useState<any>([])
  const [ newPreset, setNewPreset ] = useState<any>({ subdomain: "", rp: "" })

  const handleInputChange = (e:any) => setNewPreset({ ...newPreset, [e.target.name]: e.target.value })
  
  const handleSelectPreset = (preset:any) => {
    const newPresetsObj = {
      ...store.presets,
      active: { template: template, subdomain: preset.subdomain, rp: preset.rp },
      ready: true
    }
    update("presets", newPresetsObj)
  }

  const addNewPreset = () => savePresetFn.mutate({ resource: "preset", data: {...newPreset, template_id: template._id} })

  // useEffect(() => {
  //   console.log(_Presets)
  // },[_Presets])

  useEffect(() => {
    if( template && presets.length === 0 && _Presets ){
      const testPresetCollection = (process.env.NODE_ENV === "development") ? testPresets : []
      const firstPreset = { _id: "zzzzzzzzz", subdomain: "acme", rp: "105", template_id: template?._id }
      setPresets([..._Presets || [], ...testPresetCollection, firstPreset]) // add a default preset to the list
    } 
  },[_Presets, template])

  if( !presets.length ) return <></>
  return (
    <div 
      className={cn(
        "fixed top-[10.25rem] right-1 z-30 w-8 h-[calc(100vh-11rem)] rounded-l p-[2px] *:text-gray-200",
        expanded === true && "w-[18rem] right-[1rem] bg-teal-900",
      )}
    >
        <PresetsHandle expanded={expanded} setExpanded={setExpanded} />
        { expanded === true && (
        <div className="w-full flex flex-col">
          <PresetTitlebar />
          
          <p className="mx-4 text-xs leading-loose px-1 pb-1 mt-2 border-b border-solid border-b-white/50">Click on the preset you wish to render for. Additional options will be available after the preview renders.</p>

          <div className="flex flex-col gap-[2px] py-2">
            { presets.map( (preset:any) => (
              <div 
                key={preset._id}
                onClick={() => handleSelectPreset(preset)}
                className={cn(
                  "w-full flex justify-start items-center gap-2 py-1 px-2 cursor-pointer hover:bg-teal-950",
                  // presets.selected?._id === preset._id ? "bg-green-900 hover:bg-green-900" : "bg-transparent"
                )}
              >
                <div className="flex items-center w-2/12 h-5 text-sm justify-end">{ preset.rp }</div>
                <div className="flex items-center w-9/12 h-5 text-sm">{`${preset.subdomain.slice(0,22)}${preset.subdomain.length > 22 ? "..." : ""}` }</div>
                <div className="flex items-center w-1/12">
                  <Trash2 onClick={(e:any) => {e.stopPropagation(); console.log("trash")}} className="w-4 h-4 cursor-pointer" />
                </div>
              </div>
            ))}

            <AddPreset template={template} />

          </div>
        </div>
       )}
    </div>
  )
}